const CoupangAds = () => {
  return (
    <div style={{ display: 'flex', gap: '64px', padding: '16px' }}>
      <iframe
        title="coupangAd1"
        src="https://coupa.ng/cecqhR"
        width="120"
        height="240"
        frameBorder="0"
        scrolling="no"
        referrerPolicy="unsafe-url"
      ></iframe>
      <iframe
        title="coupangAd2"
        src="https://coupa.ng/cd4L0R"
        width="120"
        height="240"
        frameBorder="0"
        scrolling="no"
        referrerPolicy="unsafe-url"
      ></iframe>
    </div>
  );
};

export default CoupangAds;
